import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { EmailToSmsPage } from 'pages/settings/pages/emailToSms/ui/emailToSmsPage'
import { EmailToSmsLayout } from 'pages/settings/pages/emailToSms/layout/EmailToSmsLayout'
import { EmailToSmsAccessLayout } from 'pages/settings/pages/emailToSms/layout/EmailToSmsAccessLayout'

export const EmailToSmsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<EmailToSmsAccessLayout />}>
        <Route element={<EmailToSmsLayout />}>
          <Route path={'/'} element={<EmailToSmsPage />} />
        </Route>
      </Route>
    </Routes>
  )
})
